import { heatConsumptionInputsUK } from './regions/UK-heat-consumption.input'
import { heatConsumptionInputsUS } from './regions/US-heat-consumption.input'

export const heatConsumptionMapping: { [key: string]: any } = {
  US: heatConsumptionInputsUS,
  UK: heatConsumptionInputsUK,
}
